export enum AncillaryLoaderStatus {
  OFF = 'off',
  REASSIGNING = 'reassigning',
}

export enum AllowedActionsMode {
  CHECK_IN = 'check-in',
  MMB = 'mmb',
  CART = 'cart',
  INFO = 'info',
}
